module.exports = __webpack_public_path__ + "static/media/book-spells.4771c79b.svg";